import { render, staticRenderFns } from "./detailTable4.vue?vue&type=template&id=8eee3ec8&"
import script from "./detailTable4.vue?vue&type=script&lang=js&"
export * from "./detailTable4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports